import { render, staticRenderFns } from "./UserGroupUserManagement.vue?vue&type=template&id=47e96514"
import script from "./UserGroupUserManagement.vue?vue&type=script&lang=ts"
export * from "./UserGroupUserManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports